
export interface ImageAnalysis {
  isPortrait: boolean;
  isLandscape: boolean;
  aspectRatio: number;
  suggestedObjectFit: 'cover' | 'contain' | 'fill';
  suggestedObjectPosition: string;
  cardType: 'portrait' | 'landscape' | 'square';
  recommendedCardAspectRatio: number;
}

export const analyzeImage = (img: HTMLImageElement): ImageAnalysis => {
  const { naturalWidth, naturalHeight } = img;
  const aspectRatio = naturalWidth / naturalHeight;
  const isPortrait = aspectRatio < 0.8;
  const isLandscape = aspectRatio > 1.2;
  const isSquare = aspectRatio >= 0.8 && aspectRatio <= 1.2;

  let suggestedObjectFit: 'cover' | 'contain' | 'fill' = 'cover';
  let suggestedObjectPosition = 'center';
  let cardType: 'portrait' | 'landscape' | 'square' = 'square';
  let recommendedCardAspectRatio = 4/3; // Default card ratio

  // Determine card type and recommended aspect ratio
  if (isPortrait) {
    cardType = 'portrait';
    recommendedCardAspectRatio = 3/4; // Taller cards for portrait images
    suggestedObjectPosition = 'center top';
  } else if (isLandscape) {
    cardType = 'landscape';
    recommendedCardAspectRatio = 16/9; // Wider cards for landscape images
    suggestedObjectPosition = aspectRatio > 2 ? 'center top' : 'center';
  } else {
    cardType = 'square';
    recommendedCardAspectRatio = 1; // Square cards for square images
    suggestedObjectPosition = 'center';
  }

  return {
    isPortrait,
    isLandscape,
    aspectRatio,
    suggestedObjectFit,
    suggestedObjectPosition,
    cardType,
    recommendedCardAspectRatio
  };
};

export const getOptimalImageStyle = (img: HTMLImageElement) => {
  const analysis = analyzeImage(img);
  
  return {
    objectFit: analysis.suggestedObjectFit,
    objectPosition: analysis.suggestedObjectPosition
  };
};

export const getOptimalCardStyle = (img: HTMLImageElement) => {
  const analysis = analyzeImage(img);
  
  return {
    aspectRatio: analysis.recommendedCardAspectRatio,
    cardType: analysis.cardType,
    gridSpan: analysis.cardType === 'portrait' ? 'portrait' : 
              analysis.cardType === 'landscape' ? 'landscape' : 'normal'
  };
};
